module.exports = __webpack_public_path__ + "img/cy_14.png";